import { cn } from '@execonline-inc/execonline-ui';
import { EyeIcon } from '@heroicons/react/24/solid';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Tooltip } from 'react-tooltip';
import { TranslationsContext, translation } from '../../../../../../../../Translations';
import { EyeButtonProps } from './Types';

function EyeButton({ disabled, onClick, isOpen }: EyeButtonProps) {
  const ts = useContext(TranslationsContext);
  const isDisabled = disabled.getOrElseValue(false);
  const isOpenValue = isOpen.getOrElseValue(false);

  return (
    <>
      <button
        type="button"
        disabled={isDisabled}
        onClick={onClick}
        className={cn(
          '-ml-px flex items-center justify-center h-[38px] px-2.5 border bg-card hover:bg-muted transition-colors',
          isDisabled && 'opacity-50 cursor-not-allowed',
        )}
        aria-label={translation('Change display type')(ts)}
        aria-haspopup="dialog"
        aria-expanded={isOpenValue}
        data-intercom-target="builder-v2-display-type-dropdown"
        data-tooltip-id="display-type-tooltip"
        data-tooltip-content={translation('Change display type')(ts)}
      >
        <EyeIcon className="w-4 h-4 text-muted-foreground" aria-hidden="true" />
      </button>
      <Tooltip id="display-type-tooltip" place="bottom" />
    </>
  );
}

export default observer(EyeButton);
